var organisation_acces_utilisateurs_dt;

function init_administration() {
    organisation_acces_utilisateurs_dt = new DataTable('#organisation_acces_utilisateurs_dt', {
        stateSave: false,
        scrollX: true,
        searching: true,
        pageLength: 50,
        autoWidth: true,
        order: [[1, 'asc']],
        columnDefs: [{
            targets: 'no-sort',
            orderable: false,
        }, {
            targets: 'not-visible',
            visible: false,
        }],
    });

    $("#organisation_acces_utilisateurs_dt tbody").off("click", "td.details-control").on("click", "td.details-control", function() {
        ouvrir_details_datatatble_gestion_utilisateurs($(this).closest("tr"));
    });

    $("#btn_organisation_acces_utilisateurs_ouvrir_details").off("click").on("click", function () {
        var tr_a_ouvrir_ou_fermer;
        if($(this).hasClass("shown")) {
            tr_a_ouvrir_ou_fermer = $(".details-control").parent("tr.shown");
            $(this).find(".btn-ouvrir-details-txt").text("Ouvrir");
            $(this).attr("title", $(this).data("title-open"));
        } else {
            tr_a_ouvrir_ou_fermer = $(".details-control").parent("tr:not(.shown)");
            $(this).find(".btn-ouvrir-details-txt").text("Fermer");
            $(this).attr("title", $(this).data("title-close"));
        }

        $(tr_a_ouvrir_ou_fermer).each(function () {
            ouvrir_details_datatatble_gestion_utilisateurs($(this));
        });
        $(this).toggleClass("shown");
        $(this).find(".fa").toggleClass("fa-angle-down");
        $(this).find(".fa").toggleClass("fa-angle-up");
    });

    var filtre_values =  {
        filtre_municipalite : '',
        filtre_module : '',
        filtre_groupe : '',
        filtre_actif: 'true'
    };

    // Recherche et combinaison des recherches des quatres champs de filtre
    $('#filtre_municipalite, #filtre_module, #filtre_groupe, #filtre_actif').off('change').on('change', function(){
        var nom_filtre = $(this).attr('id');
        filtre_values[this.id] = $(this).val();
        if(nom_filtre=='filtre_municipalite') {
            organisation_acces_utilisateurs_dt.column(6).search(filtre_values.filtre_municipalite).draw();
        } else if(nom_filtre=='filtre_module') {
            organisation_acces_utilisateurs_dt.column(7).search(filtre_values.filtre_module).draw();
        } else if(nom_filtre=='filtre_groupe') {
            organisation_acces_utilisateurs_dt.column(8).search(filtre_values.filtre_groupe).draw();
        } else if(nom_filtre=='filtre_actif') {
            organisation_acces_utilisateurs_dt.column(9).search(filtre_values.filtre_actif).draw();
        }
    });

    // par défaut trier par actif
    $('#filtre_actif').trigger('change');

    $('#organisation_acces_utilisateurs_dt_filtres .filtre-select').select2({
        dropdownAutoWidth: true,
        allowClear: true,
        dropdownCssClass: "responsive-select2-drop"
    });

    $('#btn_creation_usager').off('click').on('click', function () {
        var url = $(this).data('url');
        let success_cb = function (response) {
            let $champs_creation_usager = $('#champs_creation_usager');
            $($champs_creation_usager).empty();
            $($champs_creation_usager).html(response);
            $('#form_modal_creation_usager').modal({
                show: true,
                backdrop: 'static'
            });

            $('#btn_save_creation_usager').off('click').on('click', function() {
                var $form = $('#frmCreateUserForm');
                let success_cb = function (response) {
                    $('#btn_email_creation_usager').removeAttr('disabled');
                    $('#btn_close_page_creation_usager').trigger('click');
                };
                let error_cb = function (response) {
                    let $champs_creation_usager = $('#champs_creation_usager');
                    $champs_creation_usager.empty();
                    $champs_creation_usager.html(response.responseText);
                    $('#form_modal_creation_usager').modal({
                        show: true,
                        backdrop: 'static'
                    });
                };
                call_ajax(url, 'post', $form.serialize(), success_cb, error_cb)
            });
        };
        call_ajax(url, 'get', null, success_cb)
});
    $('#btn_module_ville_usager').on('click', page_module_ville_usager);
    $('#btn_group_usager').on('click', page_group_usager);
    $('#btn_reset_usager').on('click', page_reset_usager);
    $('#btn_delete_usager').on('click', page_delete_usager);
}

function ouvrir_details_datatatble_gestion_utilisateurs(tr) {
    var row = organisation_acces_utilisateurs_dt.row(tr);

    if (row.child.isShown()) {
        row.child.hide();
    } else {
        row.child($(tr.find('.child-row-content').html())).show();
    }

    tr.find('.fa-details-control').toggleClass('fa-angle-down');
    tr.find('.fa-details-control').toggleClass('fa-angle-up');
    tr.toggleClass("shown");
}

function page_delete_usager() {
    wait.start();
    $('#form_modal_delete_usager').remove();
    $.ajax({
        type: "POST",
        url: "/administration/admin-delete_usager/",
        dataType: 'html',
        success: function (response) {

            $('body').append(response);

            $('#btn_page_delete_usager').on('click', delete_usager);

            $('#form_modal_delete_usager').modal({
                show: true,
                backdrop: 'static'
            });
            $('#module_delete_usager').select2();
            wait.stop();
        }
    });
}

function delete_usager() {
    removeBanniere();
    if ($('#module_delete_usager').val() == '') {
        $('#champs_delete_usager').append(getBanniereMessage('', 'Sélectionner un usager'));
    } else {
        wait.start();
        var params = {
            'user_selected': $('#module_delete_usager').val()
        };

        $.ajax({
            type: "POST",
            url: "/administration/admin-delete_usager/delete_usager/",
            data: params,
            dataType: 'html',
            success: function (response) {

                if (response == 'saved') {

                    $('#btn_close_page_delete_usager').trigger('click');
                    wait.stop();
                }
            }
        });
    }
}

function page_reset_usager() {
    wait.start();
    $('#form_modal_reset_usager').remove();
    $.ajax({
        type: "POST",
        url: "/administration/admin-reset_usager/",
        dataType: 'html',
        success: function (response) {
            $('body').append(response);
            $('#btn_save_reset_usager').on('click', save_reset_usager);
            $('#btn_email_reset_usager').on('click', email_reset_usager);
            $('#btn_email_creation_usager').on('click', email_creation_usager);
            $('#btn_doit_changer_mot_de_passe').on('click', doit_changer_mot_de_passe);

            $("#module_reset_usager").select2().on('change', function () {
                $('#btn_email_creation_usager').removeAttr('disabled');
                $('#btn_email_reset_usager').removeAttr('disabled');
                $('#btn_doit_changer_mot_de_passe').removeAttr('disabled');
            });

            $('#form_modal_reset_usager').modal({
                show: true,
                backdrop: 'static'
            });
            wait.stop();
        }
    });
}


$.extend({
    password: function (length, special) {
        var iteration = 0;
        var password = "";
        var randomNumber;
        if (special == undefined) {
            var special = false;
        }
        while (iteration < length) {
            randomNumber = (Math.floor((Math.random() * 100)) % 94) + 33;
            if (!special) {
                if ((randomNumber >= 33) && (randomNumber <= 47)) {
                    continue;
                }
                if ((randomNumber >= 58) && (randomNumber <= 64)) {
                    continue;
                }
                if ((randomNumber >= 91) && (randomNumber <= 96)) {
                    continue;
                }
                if ((randomNumber >= 123) && (randomNumber <= 126)) {
                    continue;
                }
                if ((randomNumber == 48) || (randomNumber == 79) || (randomNumber == 111) || (randomNumber == 49) || (randomNumber == 73) || (randomNumber == 108)) {
                    continue;
                }
            }
            iteration++;
            password += String.fromCharCode(randomNumber);
        }
        return password;
    }
});

function email_creation_usager() {

    wait.start();
    var params = {
        'username': $('#module_reset_usager').val(),
        'password': $('#txt_reset_password_1').val()
    };

    $.ajax({
        type: "POST",
        url: "/administration/admin-email_usager/email_creation_usager/",
        data: params,
        dataType: 'html',
        success: function (response) {

            $('#btn_close_page_reset_usager').trigger('click');
            wait.stop();

        }
    });


}

function doit_changer_mot_de_passe() {
    wait.start();
    var params = {
        'username': $('#module_reset_usager').val(),
    };
    $.ajax({
        type: "POST",
        url: "/administration/admin-email_usager/doit_changer_mot_de_passe/",
        data: params,
        dataType: 'html',
        success: function (response) {
            wait.stop();
            infos.ajouterMessageToast({
                message: "L'utilisateur devra changer son mot de passe",
                messageDuree: 0,
                messageCouleur: 'green'
            });
        }
    });
}

function email_reset_usager() {
    wait.start();
    var params = {
        'user_selected': $('#module_reset_usager').val(),
        'password_1': $('#txt_reset_password_1').val()
    };
    $.ajax({
        type: "POST",
        url: "/administration/admin-email_usager/email_reset_usager/",
        data: params,
        dataType: 'html',
        success: function (response) {
            $('#btn_close_page_reset_usager').trigger('click');
            wait.stop();
        }
    });
}

function save_reset_usager() {
    removeBanniere();
    if ($('#module_reset_usager').val() == '') {
        $('#champs_reset_usager').append(getBanniereMessage('', 'Sélectionner un usager'));
    } else {
        if ($('#txt_reset_password_1').val() != $('#txt_reset_password_2').val()) {
            $('#champs_reset_usager').append(getBanniereMessage('', 'Mot de passe différent'));
        } else {
            wait.start();

            var params = {
                'user_selected': $('#module_reset_usager').val(),
                'password_1': $('#txt_reset_password_1').val(),
                'password_2': $('#txt_reset_password_2').val()
            };

            $.ajax({
                type: "POST",
                url: "/administration/admin-reset_usager/save_reset_usager/",
                data: params,
                dataType: 'html',
                success: function (response) {
                    if (response === 'saved') {
                        $('#btn_save_reset_usager').attr('disabled', 'disabled');
                        wait.stop();
                    }
                }
            });
        }
    }
}


function page_group_usager() {
    wait.start();
    $('#form_modal_group_usager').remove();

    $.ajax({
        type: "POST",
        url: "/administration/admin-group_usager/",
        dataType: 'html',
        success: function (response) {
            $('body').append(response);
            $('#btn_save_group_usager').on('click', save_group_usager);
            $('#form_modal_group_usager').modal({
                show: true,
                backdrop: 'static'
            });
            $('#module_groupe_usager').select2();
            $('#module_groupe_usager').on('change', list_groupe_actif);
            wait.stop();
        }
    });
}


function list_groupe_actif() {
    wait.start();
    var params = {
        'user_selected': $('#module_groupe_usager').val()
    };
    $.ajax({
        type: "POST",
        url: "/administration/admin-group_usager/list_groupe_actif/",
        data: params,
        dataType: 'html',
        success: function (response) {
            $('#list_groupe_actif').html(response);
        }
    });
    wait.stop();
}


function save_group_usager() {
    removeBanniere();
    if ($('#module_groupe_usager').val() == '') {
        $('#champs_group_usager').append(getBanniereMessage('', 'Sélectionner un usager'));
    } else {
        wait.start();
        var options = $('#list_groupe_actif option');
        var groupe_selected = $.map(options, function (option) {
            return option.value;
        });

        var params = {
            'user_selected': $('#module_groupe_usager').val(),
            'groupe_selected': groupe_selected
        };

        $.ajax({
            type: "POST",
            url: "/administration/admin-group_usager/save_groupe_usager/",
            data: params,
            dataType: 'html',
            success: function (response) {
                if (response == 'saved') {
                    $('#btn_close_page_group_usager').trigger('click');
                    wait.stop();
                }
            }
        });
    }
}

function page_module_ville_usager() {
    wait.start();
    $('#form_modal_module_ville_usager').remove();
    $.ajax({
        type: "POST",
        url: "/administration/admin-module_ville_usager/",
        dataType: 'html',
        success: function (response) {
            $('#page_content').append(response);
            init_date_picker();
            $('#form_modal_module_ville_usager').modal({
                show: true,
                backdrop: 'static'
            });
            $('#module_ville_select_usager').select2();
            $('#module_copy_usager').select2();
            $('#form_modal_module_ville_usager').wizard()
            $('#form_modal_module_ville_usager').on('actionclicked.fu.wizard', function (e, info) {
                if (info.step == 1) {
                    if ($('#module_ville_select_usager').val() == '') {
                        $('#modal-step1').append(getBanniereMessage('', 'Choisir une usager'));
                        wait.stop();
                        return false;
                    }
                    // permet la copie d'un usager existant (profil au complet)
                    if ($('#module_copy_usager').val() != '') {
                        wait.start();
                        var params = {
                            'userCopy': $('#module_copy_usager').val(),
                            'userSelected': $('#module_ville_select_usager').val()
                        };
                        $.ajax({
                            type: "POST",
                            url: "/administration/admin-copy-usager/copy-profil-usager/",
                            data: params,
                            dataType: 'html',
                            success: function (response) {
                                if (response == 'copy') {
                                    list_module_actif();
                                    wait.stop();
                                    return false;
                                }
                            }
                        });
                    }
                }
            }).on('finished.fu.wizard', function (e) {
                save_usager_date_fin();
                save_notification();
                $('#close_module_ville_usager').trigger('click');
            });
            $('#module_ville_select_usager').on('change', list_module_actif);
            $('#list_modules_right').on('click', list_modules_right);
            $('#list_modules_left').on('click', list_modules_left);

            $('#list_villes_left').on('click', list_villes_left);
            $('#list_villes_right').on('click', list_villes_right);

            $('#list_groupe_left').on('click', list_groupe_left);
            $('#list_groupe_right').on('click', list_groupe_right);
            wait.stop();
        }
    });
}

function list_groupe_left() {
    $('#list_groupe_actif option:selected').remove();
}

function list_groupe_right() {
    $('#list_groupe').find('option:selected').each(function () {
        if ($("#list_groupe_actif option[value=" + $(this).val() + "]").length == 0) {
            $('#list_groupe_actif').append('<option value=' + $(this).val() + '>' + $(this).text() + '</option>');
        }
    });
}


function list_villes_left() {
    $('#list_ville_active option:selected').remove();
}

function list_villes_right() {
    $('#list_villes').find('option:selected').each(function () {
        if ($("#list_ville_active option[value=" + $(this).val() + "]").length == 0) {
            $('#list_ville_active').append('<option value=' + $(this).val() + '>' + $(this).text() + '</option>');
        }
    });
}

function list_modules_left() {
    $('#list_modules_actif option:selected').remove();
}

function list_modules_right() {
    $('#list_modules').find('option:selected').each(function () {
        if ($("#list_modules_actif option[value=" + $(this).val() + "]").length == 0) {
            $('#list_modules_actif').append('<option value=' + $(this).val() + '>' + $(this).text() + '</option>');
        }
    });
}

function getChoixSelectionne(selectedOptionId) {
    var options = $(selectedOptionId);
    return $.map(options, function (option) {
        return option.value;
    });
}

function save_module_ville_usager() {
    wait.start();

    // liste toute les villes contenu dans le select
    let ville_selected = getChoixSelectionne('#list_ville_active option');
    let module_selected = getChoixSelectionne('#list_modules_actif option');
    let groupe_selected = getChoixSelectionne('#list_groupe_actif option');

    let organisation_selected = $('#module_select_organisation').val();

    var params = {
        'user_selected': $('#module_ville_select_usager').val(),
        'ville_selected': ville_selected,
        'module_selected': module_selected,
        'groupe_selected': groupe_selected,
        'organisation_selected': organisation_selected,
        'usager_date_fin': $('#usager_date_fin').val(),
    };

    $.ajax({
        type: "POST",
        url: "/administration/admin-module_ville_usager/save_module_ville_usager/",
        data: params,
        dataType: 'html',
        success: function (response) {
            wait.stop();
            getNotificationParMunicipalite('#table-notification-administration');
        }
    });
}

let initial_date_fin = undefined;

function list_module_actif() {
    wait.start();
    var params = {
        'user_selected': $('#module_ville_select_usager').val()
    };
    $.ajax({
        type: "POST",
        url: "/administration/admin-module_ville_usager/list_module_actif/",
        data: params,
        dataType: 'html',
        success: function (response) {
            $('#list_modules_actif').html(response);
        }
    });
    $.ajax({
        type: "POST",
        url: "/administration/admin-module_ville_usager/list_ville_active/",
        data: params,
        dataType: 'html',
        success: function (response) {
            $('#list_ville_active').html(response);
            wait.stop();
        }
    });

    $.ajax({
        type: "POST",
        url: "/administration/admin-group_usager/list_groupe_actif/",
        data: params,
        dataType: 'html',
        success: function (response) {
            $('#list_groupe_actif').html(response);
        }
    });

    $.ajax({
        type: "POST",
        url: "/administration/admin-group_usager/list_organisation_actif/",
        data: params,
        dataType: 'json',
        success: function (response) {
            $('#module_select_organisation').val(response.organisation);
        }
    });

    $.ajax({
        type: "POST",
        url: "/administration/admin-module_ville_usager/usager_date_fin/",
        data: params,
        dataType: 'html',
        success: function (response) {
            if (response.length != '') {
                $("#usager_date_fin").data('daterangepicker').setStartDate(response);
                $("#usager_date_fin").val(response);
                initial_date_fin = $("#usager_date_fin").val();
            }
        }
    });

    if (document.contains(document.getElementById("notification-dataTable"))) {
        document.getElementById("notification-dataTable").remove();
    }
}


function page_creation_usager() {
    wait.start();
    $.ajax({
        type: "POST",
        url: "/administration/admin-creation_usager/",
        dataType: 'html',
        success: function (response) {
            $('#champs_creation_usager').html('');
            $('#champs_creation_usager').html(response);
            $('#form_modal_creation_usager').modal({
                show: true,
                backdrop: 'static'
            });
            $(".chosen-select").select2();
            $('#btn_save_creation_usager').off().on('click', save_creation_usager);
            wait.stop();
        }
    });
}

function save_creation_usager() {
    wait.start();
    var $form = $('#frmCreateUserForm');
    var fd = new FormData($form.get(0));

    $.ajax({
        type: "POST",
        url: "/administration/admin-creation_usager/save/",
        processData: false,
        contentType: false,
        dataType: 'html',
        data: fd,
        success: function (response) {
            if (response == 'saved') {
                $('#btn_email_creation_usager').removeAttr('disabled');
                $('#btn_close_page_creation_usager').trigger('click');
                wait.stop();
            } else {
                $('#champs_creation_usager').html(response);
                $('#form_modal_creation_usager').modal({
                    show: true,
                    backdrop: 'static'
                });
                wait.stop();
            }
        }
    });
}

function initFileInput() {
    $('input[type=file]').ace_file_input({
        style: 'well',
        btn_choose: 'Déposez un fichier ici ou cliquez pour en sélectionner un',
        btn_change: null,
        no_icon: 'ace-icon fa fa-cloud-upload',
        droppable: true,
        thumbnail: 'large'
    });
}


function getSpinner() {
    return '<h3 class="smaller lighter grey"><i class="icon-spinner icon-spin orange bigger-125"></i>Chargement des données en cours...&nbsp;&nbsp;</h3>';
}

function verificationEtape6() {
    if ($(document.getElementById('modal-step5')).hasClass('active')) {
        save_module_ville_usager();
    }
}

function save_usager_date_fin() {
    if ($('#usager_date_fin').val() !== initial_date_fin) {
        $.ajax({
            type: "POST",
            url: "/administration/admin-module_ville_usager/save_date_fin",
            data: {
                'user_selected': $('#module_ville_select_usager').val(),
                'date_fin': $('#usager_date_fin').val(),
                'csrfmiddlewaretoken': csrftoken,
            },
            success: function (response) {
                wait.stop();
            }
        });
    }
}
